<template>
  <div id="app">
    
     <modal name="ContactUs"  :width="600"
         :height="670">
       <contact-us/>
       </modal>
      <router-view/>
  </div>
 
</template>
<script>
import ContactUs from './components/ContactUs.vue';
export default {
    name: 'app',
    components: {
     ContactUs,
    },
    data () {
      return {
        isModalVisible: false,
      };
    },
    methods: {
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      }
    },
  };



</script>  
<style>
/* esri styles */
@import url('https://js.arcgis.com/4.7/esri/css/main.css');
*{
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
 
  color: #2c3e50;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  width: 100vw;
  height: 100vh;
}


</style>